import { Action, defaultActions } from '#/common/components/DataGrid';
import { Manufacturer } from '#/graphql/types';

export const actions: Action<Manufacturer>[] = [...defaultActions];
